<template lang="pug">
    div
        h2 PAGE NOT FOUND
</template>
<script>
export default {
    name: "error_404",
    data() {
        return {};
    },
    methods: {},
    mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/view/general/404.vue